import { render, staticRenderFns } from "./ScanRegistra.vue?vue&type=template&id=7d19c3ba&"
import script from "./ScanRegistra.vue?vue&type=script&lang=js&"
export * from "./ScanRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports